import React from 'react';

const SlidersHorizontalIcon = ({ ...props }) => (
  <svg viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M10.4062 12.0938H2.8125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1875 12.0938H13.2188"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8125 13.5C12.5892 13.5 13.2188 12.8704 13.2188 12.0938C13.2188 11.3171 12.5892 10.6875 11.8125 10.6875C11.0358 10.6875 10.4062 11.3171 10.4062 12.0938C10.4062 12.8704 11.0358 13.5 11.8125 13.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.90625 5.90625H2.8125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1875 5.90625H8.71875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.3125 7.3125C8.08915 7.3125 8.71875 6.6829 8.71875 5.90625C8.71875 5.1296 8.08915 4.5 7.3125 4.5C6.53585 4.5 5.90625 5.1296 5.90625 5.90625C5.90625 6.6829 6.53585 7.3125 7.3125 7.3125Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SlidersHorizontalIcon;
